import React from 'react';
import '../styles/styles.css'
import './Icon.css'
import { useThemeable } from './Provider';


interface IconProps {

  /** Name of the icon (ex: ChevronRight, Plus, HeartOutline, etc). */
  name: string;

  /** Width and height in your prefered unit of measurement */
  size?: string;

  /** Color override for the button. Uses color variables. Format should be '--color-your-variable' */
  color?: 'icon' | 'primary' | 'accent' | 'read-only' | 'positive' | 'negative' | 'informative' | 'notice' | 'text-primary' | 'text-secondary';

  /** add a custom color */
  colorCustom?: string;

  /** pass in a class */
  className?: string;

  /** removes the "extra" spacing */
  nested?: boolean;

}

/**
 * # Icon
 * Import and use Themeable icons. Your prefered icon svg file must be placed in the root directory.
 * 
 * [See Documentation](https://themeable.systems/documentation)
 * 
 * ---
 * 
 * ### Props:
 * `color`: Color override for the button.
 * 
 * `name`: Name of the icon (ex: ChevronRight, Plus, HeartOutline, etc).
 * 
 * `size`: Width and height of the icon.
 * 
 */
const Icon: React.FC<IconProps> = ({
  name,
  size = 'var(--ts-size-base)',
  color = 'icon',
  colorCustom,
  className,
  nested = false
}) => {

  const { svgPath } = useThemeable();

  const classes = [
    'icon',
    nested ? ' nested' : '',
    className ? className : '',
    `color-${color}`
  ]
    .filter(Boolean)
    .join(' ');


  return (
    <svg xmlns='http://www.w3.org/2000/svg' className={classes} style={{
      width: `${size}`,
      height: `${size}`
    }}>
      <use
        href={`${svgPath}#icon${name}`}
        style={{ fill: colorCustom }}
      />
    </svg>

  )
};

export type { IconProps }

export { Icon };
